<template>
  <div>
    <section class="banner-sec bg bg-6">
      <div class="container">
        <div class="bg-content">
          <h1 class="size-40 regular hidden-br">Encontrá un nuevo grupo de <br/>clientes habituales</h1>
          <p class="size-20">Hay un mercado sin explotar que está esperando probar tu comida.</p>
          <div class="banner-btn"><a type="button" data-toggle="modal" data-target="#partner" class="btn btn-hg btn-primary btn-fill">COMENZAR</a></div>
        </div>
      </div>
    </section>
    <section class=" section white padding-tb-160 nopad-top-sm">
      <div class="float-element fe-5"></div>
      <div class="container">
        <div class="row">
          <div class="col-xs-12 col-sm-12 visible-xs visible-sm">
            <img class="img-section" src="/images/backgrounds/bg8.png"/>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <div class="box-text sm-centered">
              <h1 class="lato size-34">Hacé crecer tu negocio</h1>
              <p class="size-16 margin-bottom-10"><span class="semibold">Atraé nuevos clientes sin esfuerzo.</span></p>
              <p class="size-16 margin-bottom-20">Asociate a <span class="regular">andalepide</span> y conseguí un retorno sustancial a través de grandes pedidos. Generá ingresos adicionales más allá de lo cotidiano.</p>
              <p class="size-16 margin-bottom-30"><span class="regular">Andalepide</span> trabaja con restaurantes de alta calidad, servicios de catering, bares y deliverys de Córdoba Capital.</p>
              <div class="box-text-btn">
                <a type="button" data-toggle="modal" data-target="#partner" class="btn btn-fill">SUMATE COMO PARTNER</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section bg bg-7 no-padding">
      <div class="container">
        <div class="bg-content">
          <h1 class="size-40 regular">Maximizá tu producción</h1>
          <p class="size-18 bold">Usa tu cocina al 100% todos los días</p>
          <p class="size-20"><span class="semibold">Andalepide</span> aunmenta el flujo de pedidos diarios, incrementando tus ventas. <br/>Con nuestro servicio, vas a poder planificar con antelación tu producción, organizar tus compras <br/>y hacer que tu servicio sea más eficiente.</p>
        </div>
      </div>
    </section>
    <section class="section white">
      <div class="container">
        <div class="head-text">
          <h1 class="lato size-34">Con el respaldo de un socio de confianza</h1>
          <p class="subtitle">Está en nuestra esencia formar relaciones duraderas y mutuamente beneficiosas con nuestros proveedores. <br/>Trabajamos para conformar una relación que no sólo brinde beneficios financieros, sino también de exposición y de gestión para su empresa. </p>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <div class="box-text margin-bottom-40 sm-centered">
              <p class="size-16"><span class="semibold">Pedidos con antelación</span><br/>andalepide envía órdenes con importante tiempo de anticipacion, para que pueda planificar la semana completa, preparar sus recetas minuciosamente y hacer las entregas organizadas.</p>
              <p class="size-16">Nuestro software está diseñado para que puedas organizar tu cocina, otorgar permisos de usos a tu personal, acceder a información inteligente de todos los pedidos recibidos y llevar una contabilidad sencilla.</p>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <div class="box-text margin-bottom-40 sm-centered">
              <p class="size-16"><span class="semibold">Simplificamos la logística</span><br/>Hemos diseñado un sistema simple, con el cual vas a obtener la informacion exacta de cada pedido. Además, vas a poder coordinar perfectamente todas las entregas, mediante un formulario de pedidos y entregas que establecen claramente el tipo de comida, cantidad de personas, nombre y apellido asignado a cada plato y horario de entrega.</p> 
              <p class="size-16">Asimismo, siempre vas a contar con nuestro servicio de soporte para poder abordar todas tus consultas.</p>
            </div>
          </div>  
          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <div class="box-text margin-bottom-40 sm-centered">
              <p class="size-16"><span class="semibold">Soporte contínuo</span><br/>Nuestro está pendiente de tu trabajo y tus dudas, definiremos una persona que atenderá exclusivamente todas tus consultas y te guiará en lo que necesites. </p>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <div class="box-text margin-bottom-40 sm-centered">
              <p class="size-16"><span class="semibold">Exposición</span><br/>Trabajaremos juntos para promocionar tu trabajo en nuestra plataforma y todos nuestros canales de comunicación.</p>
            </div>
          </div>  
        </div>
      </div>
    </section>
    <section class="section grey">
      <div class="container">
        <div class="head-text">
          <h1 class="lato size-34">Sumate como partner hoy</h1>
          <p class="size-16 hidden-br">Andalepide atrae a empresas con gran número de empleados. Sé parte de la red de entrega <br/>de comidas en Córdoba Capital. Próximamente más ciudades.</p>     
        </div>
        <div class="box-text centered">
          <div class="box-text-btn">
            <a type="button" data-toggle="modal" data-target="#partner" class="btn btn-primary btn-fill">COMENZÁ AHORA</a>
          </div>
        </div>
      </div>
    </section>
    <!-- Modal Suscribe -->
    <div class="modal fade" id="subscribe" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <h2>Suscribite a Andalepide</h2>
        <p class="size-16">¿Estás listo para recibir a diario el menú más variado de comidas de tu ciudad?<br/>Completa este formulario y un representante nuestro se contactará con vos.</p>
        <form class="form modal-form">
          <div class="row">
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <div class="form-group">
                <label>Nombre y Apellido</label>
                <input type="text" name="" class="form-control"/>
              </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <div class="form-group">
                <label>Empresa</label>
                <input type="text" name="" class="form-control"/>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <div class="form-group">
                <label>N° de Empleados</label>
                <input type="text" name="" class="form-control"/>
              </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <div class="form-group">
                <label>Barrio o Zona</label>
                <input type="text" name="" class="form-control"/>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <div class="form-group">
                <label>E-Mail</label>
                <input type="mail" name="" class="form-control"/>
              </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <div class="form-group">
                <label>Teléfono</label>
                <input type="text" name="" class="form-control"/>
              </div>
            </div>
          </div>
          <div class="form-action">
            <a href="login.html" class="btn-link deco-dotted pull-left">¿Ya tienes una cuenta?</a>
            <button type="button" class="btn btn-fill">ENVIAR</button>
          </div>
        </form>
        </div>
      </div>
      </div>
    </div><!-- Fin modal suscribe-->
    
    <!-- Modal Partner -->
    <div class="modal fade" id="partner" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <h2>Sumate como Partner</h2>
        <p class="size-16">Asociate a Andalepite y hacé crecer tu negocio con un mercado inexplorado en tu ciudad.</p>
        <form class="form modal-form">
          <div class="row">
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <div class="form-group">
                <label>Nombre</label>
                <input type="text" name="" class="form-control"/>
              </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <div class="form-group">
                <label>Apellido</label>
                <input type="text" name="" class="form-control"/>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <div class="form-group">
                <label>Nombre de tu empresa</label>
                <input type="text" name="" class="form-control"/>
              </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <div class="form-group">
                <label>Tipo de cocina</label>
                <input type="text" name="" class="form-control"/>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <div class="form-group">
                <label>Barrio o Zona</label>
                <input type="text" name="" class="form-control"/>
              </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <div class="form-group">
                <label>Web o fanpage de Facebook</label>
                <input type="text" name="" class="form-control"/>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <div class="form-group">
                <label>E-Mail</label>
                <input type="mail" name="" class="form-control"/>
              </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <div class="form-group">
                <label>Teléfono</label>
                <input type="text" name="" class="form-control"/>
              </div>
            </div>
          </div>
          <div class="form-action">
            <button type="button" class="btn btn-fill">ENVIAR</button>
          </div>
        </form>
        </div>
      </div>
      </div>
    </div><!-- Fin modal partner-->
  </div>
  
</template>
<script>
  import $ from 'jquery'
  export default {
    mounted () {
      $('html, body').animate({ scrollTop: 0 }, 'slow')
    }
  }
</script>



// WEBPACK FOOTER //
// Partners.vue?f3b5dcca